import React, { useState, useEffect, useRef } from "react";
import ReactSlider from "react-slider";

function DashboardYearStrip({ onSliderChange, years, timeLineToggle, setShowAggregated, showAggregated }) {
  const decadeYears = years.filter(year => year % 10 === 0 || year === 1990 || year === 2020);

  const [sliderValue, setSliderValue] = useState(1990);
  const [isPlaying, setIsPlaying] = useState(false);
  const sliderIntervalRef = useRef(null);

  const handlePlayPause = () => {
    if (sliderValue === 2020) {
      setSliderValue(1990)
    }
    setIsPlaying(prevState => !prevState);
  };

  useEffect(() => {
    if (showAggregated) {
      setIsPlaying(false);
    }
  }, [showAggregated]);

  useEffect(() => {
    if (isPlaying) {
      setShowAggregated(false);
      sliderIntervalRef.current = setInterval(() => {
        setSliderValue(prevValue => {
          const nextValue = prevValue + 1;
          if (nextValue > 2020) {
            clearInterval(sliderIntervalRef.current);
            setIsPlaying(false);
            return 1990;
          }
          return nextValue;
        });
      }, 1000);
    } else {
      clearInterval(sliderIntervalRef.current);
    }

    return () => clearInterval(sliderIntervalRef.current);
  }, [isPlaying]);

  useEffect(() => {
    // Call the callback function whenever the slider value changes
    if (onSliderChange) {
      onSliderChange(sliderValue);
    }
  }, [sliderValue, onSliderChange]);

  return (
    <>
      <div className={`timeline-slider-container ${timeLineToggle}`}>
        <div className="playpause">
          <input
            type="checkbox"
            checked={isPlaying}
            onChange={handlePlayPause}
            id="playpause"
            name="check"
          />
          <label htmlFor="playpause"></label>
        </div>
        <ReactSlider
          className="timeline-slider"
          thumbClassName="timeline-thumb"
          trackClassName="timeline-track"
          min={1990}
          max={2020}
          step={1}
          value={sliderValue}
          onChange={setSliderValue}
          renderMark={(props, state) => (
            <span
              {...props}
              className={`timeline-mark ${state ? state.className : ''}`}
            >
              {props.value}
            </span>
          )}
        />
        <div className="timeline-labels">
          {decadeYears.map((year) => (
            <span key={year} className="timeline-label">
              {year}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

export default DashboardYearStrip;